// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AppInsightsProvider from "@store/Framework/Components/AppInsightsProvider";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { AnchorContextProvider } from "@toolkit/Framework/Components/AnchorContext";
import { NamedContextProvider } from "@toolkit/Framework/Components/NamedContext";
import { SiteContextProvider, useSiteContext } from "@toolkit/Framework/Components/SiteContext";
import { WindowContextProvider } from "@toolkit/Framework/Components/WindowContext";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React, { FC, PropsWithChildren, useMemo } from "react";
import { css } from "styled-components";

export interface SiteWrapperPresentationProps extends ExpandStyles<SiteWrapperStyles> {}

export interface SiteWrapperProps extends SiteWrapperPresentationProps {}

export interface SiteWrapperStyles {
    wrapper?: InjectableCss;
}

export const siteWrapperStyles: SiteWrapperStyles = {
    wrapper: {
        css: css`
            min-height: 100vh;
            display: flex;
            flex-direction: column;

            @media print {
                display: block; /* Required for PDF Generation */
            }
        `,
    },
};

const Wrapper: FC<PropsWithChildren<SiteWrapperProps>> = ({
    children,
    extendedStyles,
    overridedStyles,
    ...htmlAttributes
}) => {
    const styles = useExpandProps(siteWrapperStyles, extendedStyles, overridedStyles);
    const { bottomSpacing } = useSiteContext();

    const wrapperCss = useMemo(() => {
        return css`
            ${bottomSpacing ? `padding-bottom: ${bottomSpacing}px;` : null}
            ${styles.wrapper?.css}
        `;
    }, [styles.wrapper, bottomSpacing]);

    return (
        <StyledWrapper {...styles.wrapper} css={wrapperCss} {...htmlAttributes}>
            {children}
        </StyledWrapper>
    );
};

const SiteWrapper: FC<SiteWrapperProps> = props => {
    const currentPageType = useCurrentPage().type;

    return (
        <AppInsightsProvider>
            <WindowContextProvider>
                <NamedContextProvider value={currentPageType}>
                    <AnchorContextProvider>
                        <SiteContextProvider>
                            <Wrapper {...props} />
                        </SiteContextProvider>
                    </AnchorContextProvider>
                </NamedContextProvider>
            </WindowContextProvider>
        </AppInsightsProvider>
    );
};

export default SiteWrapper;
